<template>
  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.key"
             type="text"
             class="form-control"
             :disabled="keyReadonly"
             :placeholder="$t('general_terms.key')">
      <label>{{ $t('general_terms.key') }}</label>
    </div>
    <small class="text-muted">{{ $t('general_terms.key_hint') }}</small>
  </div>

  <div class="col-12 col-lg-8 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.title"
             type="text"
             class="form-control"
             :placeholder="$t('general_terms.title')">
      <label>{{ $t('general_terms.title') }}</label>
    </div>
  </div>

  <div class="col-12 mb-3">
    <label class="form-label">{{ $t('general_terms.content') }}</label>
    <textarea v-model="localFormData.content"
              class="form-control content-textarea"
              :placeholder="$t('general_terms.content_placeholder')"></textarea>
  </div>
</template>

<script>
export default {
  name: 'GeneralTermFormFields',
  props: {
    formData: {
      type: Object,
      required: true,
    },
    keyReadonly: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:formData'],
  data() {
    return {
      localFormData: {...this.formData},
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.localFormData)) {
          this.localFormData = {...newValue}
        }
      }
    },
    localFormData: {
      deep: true,
      handler(newValue) {
        this.$emit('update:formData', {...newValue})
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content-textarea {
  min-height: 320px;
  font-family: inherit;
}
</style>
